import type { ProofsOfConclusion } from './definitions';
import { proofsOfConclusionTransformer } from './proofOfConclusionTransformer';

import type { TimestampInMillis } from '@cobliteam/common-types';

import type { Configuration } from '../..';
import HttpMethod from '../../request/HttpMethod';
import Requester from '../../request/Requester';
import type { IRequest } from '../../request/Types';

export class ProofOfConclusionRequester {
  private requester: Requester;

  constructor(configuration: Configuration) {
    this.requester = new Requester(configuration);
  }

  public load = (
    limit: number,
    offset: number,
    startTimestamp?: TimestampInMillis,
    endTimestamp?: TimestampInMillis
  ): Promise<ProofsOfConclusion> => {
    const requestData: IRequest = {
      endpoint: '/planning/pocs',
      method: HttpMethod.GET,
      params: {
        limit,
        offset,
        startTimestamp,
        endTimestamp,
      },
    };

    return this.requester
      .request(requestData)
      .then((response) => proofsOfConclusionTransformer(response.data));
  };
}

export default ProofOfConclusionRequester;
